import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private sidebarCollapsed = new BehaviorSubject<boolean>(false);
  public sidebarCollapsed$ = this.sidebarCollapsed.asObservable();

  toggle(): void {
    this.sidebarCollapsed.next(!this.sidebarCollapsed.value);
  }

  collapse(): void {
    this.sidebarCollapsed.next(true);
  }

  expand(): void {
    this.sidebarCollapsed.next(false);
  }

  getState(): boolean {
    return this.sidebarCollapsed.value;
  }
}
